import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { Star, ShieldCheck, ChevronDown, ChevronUp, Clock, Lock, CreditCard } from 'lucide-react';
export const Testimonials2 = () => {
  const testimonials = [{
    initials: 'LM',
    name: 'Luciana M.',
    location: 'Mendoza | El Arsenal del Profe',
    text: 'Tengo 12 grupos distintos por semana. Antes llegaba agotada al lunes. Ahora abro el tomo que necesito y listo. No hay vuelta atrás.'
  }, {
    initials: 'JP',
    name: 'Juan P.',
    location: 'La Plata | Arsenal + Potenciador',
    text: 'El Tomo 1 me salvó el día que llegué y el depósito estaba con llave. Hice una clase entera sin un solo material y los chicos no se dieron cuenta.'
  }, {
    initials: 'VR',
    name: 'Valeria R.',
    location: 'Santa Fe | Escuela Secundaria',
    text: 'El Potenciador me cambió la forma de usar las pelotas y los conos. Mis alumnos de 4to año me preguntan si vamos a hacer el circuito de nuevo.'
  }, {
    initials: 'FA',
    name: 'Federico A.',
    location: 'Neuquén | Instructor Deportivo',
    text: 'No soy profe de escuela pero guío grupos de actividad física. Funciona igual de bien para mí. El Bono de Frases GAP es oro puro.'
  }];
  return <Section className="bg-[#060f1c]" data-id="element-187">
      <FadeIn className="text-center mb-4 md:mb-10" data-id="element-188">
        <h2 className="text-xl md:text-4xl font-bold text-white mb-1.5 md:mb-3" data-id="element-189">
          Lo que dicen los profes
        </h2>
        <div className="flex items-center justify-center gap-1.5 md:gap-2 text-gray-300 text-[11px] md:text-base" data-id="element-190">
          <div className="flex text-yellow-400" data-id="element-191">
            {[...Array(5)].map((_, j) => <Star key={j} className="fill-current w-[11px] h-[11px] md:w-[14px] md:h-[14px]" data-id="element-192" />)}
          </div>
          <span className="font-semibold" data-id="element-193">4.9/5</span>
          <span className="text-gray-500" data-id="element-194">·</span>
          <span data-id="element-195">+500 profes del país</span>
        </div>
      </FadeIn>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2.5 md:gap-6" data-id="element-196">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-197">
            <div className="bg-[#0c1626] p-3 md:p-6 rounded-xl md:rounded-2xl shadow-sm border border-white/10 h-full flex flex-col hover:shadow-md transition-shadow" data-id="element-198">
              <div className="flex items-center gap-2.5 md:gap-3 mb-2 md:mb-4" data-id="element-199">
                <div className="w-8 h-8 md:w-10 md:h-10 bg-brandOrange text-white rounded-full flex items-center justify-center font-bold text-[11px] md:text-sm shrink-0" data-id="element-200">
                  {t.initials}
                </div>
                <div className="min-w-0 flex-1" data-id="element-201">
                  <div className="flex text-yellow-400 mb-0.5 md:mb-1" data-id="element-202">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-203" />)}
                  </div>
                  <p className="font-bold text-white text-[12px] md:text-sm leading-tight truncate" data-id="element-204">
                    {t.name}
                  </p>
                  <p className="text-[10px] md:text-xs text-gray-400 truncate" data-id="element-205">
                    📍 {t.location}
                  </p>
                </div>
              </div>
              <p className="text-gray-300 text-[12px] md:text-sm italic leading-snug" data-id="element-206">
                "{t.text}"
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Guarantee = () => {
  return <Section className="bg-[#070f1e] text-white" data-id="element-207">
      <FadeIn className="max-w-xl mx-auto" data-id="element-208">
        <div className="bg-[#0c1626] border border-brandOrange/30 rounded-2xl p-5 md:p-7 text-center shadow-lg shadow-brandOrange/5" data-id="element-209">
          <ShieldCheck size={44} className="mx-auto text-brandOrange mb-3 md:mb-4" data-id="element-210" />
          <h2 className="text-lg md:text-2xl font-bold mb-3 md:mb-4 leading-tight" data-id="element-211">
            🛡️ GARANTÍA 30 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="text-sm md:text-base text-gray-300 space-y-1.5 md:space-y-2 mb-3 md:mb-4 leading-snug" data-id="element-212">
            <p data-id="element-213">Abrís los tomos. Los usás en clase.</p>
            <p className="text-white font-bold text-base md:text-lg py-1" data-id="element-214">
              Si en 30 días no es lo que esperabas:
              <br data-id="element-215" />
              devolución del 100%.
            </p>
            <p data-id="element-216">Sin formularios. Sin drama. Sin vueltas.</p>
            <p className="text-xs md:text-sm" data-id="element-217">
              Un mail a{' '}
              <a href="mailto:soportecentershop95@gmail.com" className="text-brandOrange hover:underline break-all" data-id="element-218">
                soportecentershop95@gmail.com
              </a>{' '}
              y listo.
            </p>
          </div>
          <p className="text-[11px] md:text-xs text-gray-500 font-medium" data-id="element-219">
            Tasa de devoluciones: menos del 2%.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve para primaria y secundaria?',
    a: 'Sí. Los 6 Tomos están pensados para ambos niveles. Cada actividad indica para qué edad y contexto funciona mejor.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. PDF de alta calidad. Acceso inmediato al pago. En menos de 5 minutos tenés todo en tu celular o computadora.'
  }, {
    q: '¿Funciona si no soy profe de escuela?',
    a: 'Sí. Cualquier persona que guíe grupos de actividad física (instructores, animadores, recreadores, profesores particulares) puede usar este sistema sin problema.'
  }, {
    q: '¿Necesito materiales deportivos para usarlo?',
    a: 'No. Los 6 Tomos del Arsenal están diseñados para funcionar sin ningún material. El Potenciador (upsell opcional) usa materiales que ya están en cualquier escuela o gimnasio.'
  }, {
    q: '¿Tiene garantía real?',
    a: '30 días. Sin preguntas. Sin formularios. Un mail y te devolvemos el 100%.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-[#060f1c]" data-id="element-220">
      <FadeIn className="max-w-3xl mx-auto" data-id="element-221">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-10" data-id="element-222">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>
        <div className="space-y-4" data-id="element-223">
          {faqs.map((faq, i) => <div key={i} className="bg-[#0c1626] border border-white/10 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow" data-id="element-224">
              <button className="w-full px-6 py-4 text-left font-bold text-white flex justify-between items-center hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-225">
                <span data-id="element-226">{faq.q}</span>
                {openIndex === i ? <ChevronUp className="text-brandOrange" data-id="element-227" /> : <ChevronDown className="text-gray-400" data-id="element-228" />}
              </button>
              {openIndex === i && <div className="px-6 pb-4 text-gray-300" data-id="element-229">{faq.a}</div>}
            </div>)}
        </div>
      </FadeIn>
    </Section>;
};
export const CostOfNotHaving = () => {
  const costs = [{
    sin: '3 horas de búsqueda de juegos por semana',
    costo: '120 horas de tu vida por año'
  }, {
    sin: 'Clases sin estructura',
    costo: 'Grupos que se te van de las manos'
  }, {
    sin: 'Sin plan B para lluvia',
    costo: 'Clase perdida + estrés innecesario'
  }, {
    sin: 'Sin consignas listas',
    costo: 'Explicás 3 veces y la mitad no entiende'
  }, {
    sin: 'Siempre los mismos juegos',
    costo: 'Grupos que se aburren y no participan'
  }, {
    sin: 'Domingo buscando en Google',
    costo: 'El mismo ciclo, el próximo año'
  }];
  return <Section className="bg-[#070f1e] text-white" data-id="element-230">
      <FadeIn className="max-w-4xl mx-auto" data-id="element-231">
        <h2 className="text-xl md:text-4xl font-bold text-center mb-4 md:mb-12 text-brandOrange leading-tight" data-id="element-232">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-white/5 rounded-xl md:rounded-3xl overflow-hidden border border-white/10 mb-5 md:mb-10" data-id="element-233">
          <div className="grid grid-cols-2 bg-white/10 px-2.5 py-2 md:p-4 font-bold text-[11px] md:text-base" data-id="element-234">
            <div className="text-gray-300" data-id="element-235">Sin El Arsenal</div>
            <div className="text-white pl-2.5 md:pl-4 border-l border-white/10" data-id="element-236">
              Costo real
            </div>
          </div>
          <div className="divide-y divide-white/5" data-id="element-237">
            {costs.map((row, i) => <div key={i} className="grid grid-cols-2 px-2.5 py-2.5 md:p-6 gap-2.5 md:gap-4 text-[11px] md:text-base items-center hover:bg-white/5 transition-colors leading-snug" data-id="element-238">
                <div className="text-gray-400 pr-1.5 md:pr-4" data-id="element-239">{row.sin}</div>
                <div className="text-red-400 font-medium pl-2.5 md:pl-4 border-l border-white/10 flex items-center gap-1.5 md:gap-2" data-id="element-240">
                  <span className="hidden md:inline" data-id="element-241">→</span> {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center space-y-1.5 md:space-y-4" data-id="element-242">
          <p className="text-lg md:text-3xl font-bold text-white leading-tight" data-id="element-243">
            El próximo domingo puede ser diferente.
          </p>
          <p className="text-xs md:text-lg text-gray-300 max-w-2xl mx-auto leading-snug" data-id="element-244">
            Podés improvisar la próxima clase, o entrar con todo resuelto.
          </p>
          <p className="text-base md:text-2xl font-bold text-brandOrange" data-id="element-245">
            Vos decidís.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const FinalCTA = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  const offers = {
    plus: {
      checkoutUrl: 'https://www.centershop.store/cart/47776144556183:1',
      cta: 'QUIERO EL ARSENAL + POTENCIADOR',
      value: 27990,
      contentName: 'MegaPack Arsenal + Potenciador',
      contentId: 'arsenal-potenciador'
    },
    basic: {
      checkoutUrl: 'https://www.centershop.store/cart/47775955288215:1',
      cta: 'QUIERO MI ARSENAL AHORA',
      value: 19990,
      contentName: 'MegaPack El Arsenal del Profe',
      contentId: 'arsenal-basico'
    }
  } as const;
  const current = offers[selected];
  return <Section className="bg-[#060f1c] border-t border-white/10 pt-16 pb-24" data-id="element-246">
      <FadeIn className="max-w-3xl mx-auto text-center" data-id="element-247">
        <div className="inline-flex items-center gap-2 bg-red-500/15 border border-red-500/40 text-red-300 font-bold px-4 py-1.5 rounded-full mb-6 md:mb-8 text-xs md:text-sm uppercase tracking-wide" data-id="element-248">
          🚨 Última oportunidad
        </div>
        <div className="mb-8 md:mb-12" data-id="element-249">
          <div className="inline-flex items-center gap-2 bg-brandOrange/10 border border-brandOrange/30 px-3 py-1 rounded-full mb-3 md:mb-4" data-id="element-250">
            <span className="w-1.5 h-1.5 rounded-full bg-brandOrange animate-pulse" data-id="element-251"></span>
            <span className="text-[10px] md:text-xs font-bold text-brandOrange uppercase tracking-[0.2em]" data-id="element-252">
              El precio cierra en
            </span>
          </div>
          <div className="inline-flex items-center gap-1.5 md:gap-3 bg-[#070f1e] border-2 border-brandOrange rounded-2xl md:rounded-3xl px-3 py-3 md:px-6 md:py-5 animate-counter-glow" data-id="element-253">
            <div className="flex flex-col items-center min-w-[58px] md:min-w-[78px]" data-id="element-254">
              <div className="text-3xl md:text-5xl font-black text-brandOrange leading-none tabular-nums" data-id="element-255">
                {hours.toString().padStart(2, '0')}
              </div>
              <div className="text-[9px] md:text-[10px] text-gray-400 mt-1.5 md:mt-2 uppercase font-bold tracking-[0.2em]" data-id="element-256">
                hs
              </div>
            </div>
            <div className="text-2xl md:text-4xl font-black text-brandOrange/60 leading-none -mt-3 md:-mt-4" data-id="element-257">
              :
            </div>
            <div className="flex flex-col items-center min-w-[58px] md:min-w-[78px]" data-id="element-258">
              <div className="text-3xl md:text-5xl font-black text-brandOrange leading-none tabular-nums" data-id="element-259">
                {minutes.toString().padStart(2, '0')}
              </div>
              <div className="text-[9px] md:text-[10px] text-gray-400 mt-1.5 md:mt-2 uppercase font-bold tracking-[0.2em]" data-id="element-260">
                min
              </div>
            </div>
            <div className="text-2xl md:text-4xl font-black text-brandOrange/60 leading-none -mt-3 md:-mt-4 animate-pulse" data-id="element-261">
              :
            </div>
            <div className="flex flex-col items-center min-w-[58px] md:min-w-[78px]" data-id="element-262">
              <div className="text-3xl md:text-5xl font-black text-brandOrange leading-none tabular-nums animate-pulse" data-id="element-263">
                {seconds.toString().padStart(2, '0')}
              </div>
              <div className="text-[9px] md:text-[10px] text-gray-400 mt-1.5 md:mt-2 uppercase font-bold tracking-[0.2em]" data-id="element-264">
                seg
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4 md:space-y-5 mb-8 md:mb-10" data-id="element-265">
          {/* Option Plus - MÁS ELEGIDO */}
          <button type="button" onClick={() => setSelected('plus')} className={`w-full text-left rounded-3xl p-5 md:p-7 relative transition-all duration-300 border-2 ${selected === 'plus' ? 'bg-[#0a1320] border-brandOrange' : 'bg-[#0a1320]/40 border-white/10 hover:border-white/25 opacity-70 hover:opacity-90'}`} data-id="element-266">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-brandOrange text-white px-4 py-1 rounded-full text-xs font-bold whitespace-nowrap" data-id="element-267">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="flex items-start gap-3 md:gap-4" data-id="element-268">
              <div className={`w-6 h-6 rounded-full border-2 mt-1 shrink-0 flex items-center justify-center ${selected === 'plus' ? 'border-brandOrange' : 'border-gray-500'}`} data-id="element-269">
                {selected === 'plus' && <div className="w-3 h-3 rounded-full bg-brandOrange" data-id="element-270"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-271">
                <h4 className="text-lg md:text-2xl font-bold text-white mb-1 leading-tight" data-id="element-272">
                  🏆 ARSENAL + POTENCIADOR
                </h4>
                <p className="text-brandOrange text-xs md:text-sm font-medium" data-id="element-273">
                  6 Tomos + 6 Bonos + 6 Volúmenes Potenciador
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-274">
                <p className="text-gray-500 line-through text-xs md:text-sm" data-id="element-275">
                  $49.990
                </p>
                <p className={`text-2xl md:text-3xl font-black ${selected === 'plus' ? 'text-brandOrange' : 'text-white'}`} data-id="element-276">
                  $27.990
                </p>
              </div>
            </div>
          </button>

          {/* Option Basic */}
          <button type="button" onClick={() => setSelected('basic')} className={`w-full text-left rounded-3xl p-5 md:p-7 transition-all duration-300 border-2 ${selected === 'basic' ? 'bg-[#0a1320] border-brandOrange' : 'bg-[#0a1320]/40 border-white/10 hover:border-white/25 opacity-70 hover:opacity-90'}`} data-id="element-277">
            <div className="flex items-start gap-3 md:gap-4" data-id="element-278">
              <div className={`w-6 h-6 rounded-full border-2 mt-1 shrink-0 flex items-center justify-center ${selected === 'basic' ? 'border-brandOrange' : 'border-gray-500'}`} data-id="element-279">
                {selected === 'basic' && <div className="w-3 h-3 rounded-full bg-brandOrange" data-id="element-280"></div>}
              </div>
              <div className="flex-grow min-w-0" data-id="element-281">
                <h4 className="text-lg md:text-2xl font-bold text-white mb-1 leading-tight" data-id="element-282">
                  📘 EL ARSENAL DEL PROFE
                </h4>
                <p className="text-gray-400 text-xs md:text-sm" data-id="element-283">
                  6 Tomos + 6 Bonos · Primaria + Secundaria
                </p>
              </div>
              <div className="text-right shrink-0" data-id="element-284">
                <p className="text-gray-500 line-through text-xs md:text-sm" data-id="element-285">
                  $34.990
                </p>
                <p className={`text-2xl md:text-3xl font-black ${selected === 'basic' ? 'text-brandOrange' : 'text-white'}`} data-id="element-286">
                  $19.990
                </p>
              </div>
            </div>
          </button>

          <CTAButton href={current.checkoutUrl} fullWidth className="text-sm md:text-xl py-3 md:py-5 mt-2 md:mt-4 animate-glow-button" trackEvent={{
          name: 'InitiateCheckout',
          params: {
            value: current.value,
            currency: 'ARS',
            content_name: current.contentName,
            content_ids: [current.contentId],
            content_type: 'product',
            num_items: 1
          }
        }} data-id="element-287">
            {current.cta} →
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 font-medium" data-id="element-288">
          <span className="flex items-center gap-2" data-id="element-289">
            <Lock size={18} data-id="element-290" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-291">
            <Clock size={18} data-id="element-292" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-293">
            <ShieldCheck size={18} data-id="element-294" /> Garantía 30 días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2" data-id="element-295">
            <CreditCard size={18} data-id="element-296" /> Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </FadeIn>
    </Section>;
};
export const Footer = () => {
  return <footer className="bg-[#04080f] text-gray-400 py-12 px-4 border-t border-white/5" data-id="element-297">
      <div className="max-w-4xl mx-auto text-center space-y-6" data-id="element-298">
        <div data-id="element-299">
          <h2 className="text-2xl font-black text-white mb-1" data-id="element-300">
            ⚽ EL ARSENAL DEL PROFE™
          </h2>
          <p className="text-sm" data-id="element-301">by CenterShop Digital</p>
        </div>

        <p className="text-gray-300 max-w-md mx-auto" data-id="element-302">
          El sistema de clases listas N°1 para profes de Educación Física en
          Argentina. Porque dar una buena clase no debería costarte todos los
          domingos del año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm pt-4" data-id="element-303">
          <a href="mailto:soportecentershop95@gmail.com" className="hover:text-white transition-colors" data-id="element-304">
            📧 soportecentershop95@gmail.com
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-305">
            📲 @centershop.digital
          </a>
        </div>

        <div className="pt-8 border-t border-white/10 text-xs space-y-2" data-id="element-306">
          <p data-id="element-307">© 2024 CenterShop Digital. Todos los derechos reservados.</p>
          <p className="space-x-4" data-id="element-308">
            <a href="#" className="hover:text-white transition-colors" data-id="element-309">
              Términos y condiciones
            </a>
            <span data-id="element-310">·</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-311">
              Política de privacidad
            </a>
          </p>
        </div>
      </div>
    </footer>;
};